const findDuplicatesInArrays = (arr1, arr2) => {
  const map = new Map();
  const duplicates = [];

  // Count occurrences of each element in arr1
  arr1.forEach(item => {
    map.set(item, (map.get(item) || 0) + 1);
  });

  // Check elements in arr2 for duplicates
  arr2.forEach(item => {
    // If item is found in arr1 and not already added to duplicates
    if (map.has(item) && !duplicates.includes(item)) {
      duplicates.push(item);
    }
  });

  return duplicates;
}

export default findDuplicatesInArrays;